import React, { Component } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
 import Projects from '../api/project'

class SliderProject extends Component {
    render() {
        const { imagecarrousel,title,isCarrousel } = this.props;
        var settings = {
            dots: false,
            arrows: true,
            speed: 1000,
            slidesToShow: isCarrousel? 2 : 1,
            slidesToScroll: 1,
            autoplay: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow:isCarrousel? 2 : 1,
                        slidesToScroll: 1,
                        infinite: isCarrousel? true : false ,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: isCarrousel? 2 : 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };
        const ClickHandler = () => {
            window.scrollTo(10, 0);
        }


        return (
            <div className="wpo-project-area ">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="wpo-project-wrap project-active owl-carousel no-hover">
                            <Slider {...settings}>
                                {imagecarrousel.map((image, pot) => (
                                    <div className="wpo-project-item" key={pot}>
                                        <div className="wpo-project-imj">
                                            <img className='object-fit-cover' width={"100%"} height={isCarrousel? 295 : 460} src={image} alt={`${title} carousel-item-${pot}`} style={{ objectFit: 'cover' }} />
                                            
                                        </div>
                                         
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SliderProject;

